import React from "react";
import i18n from "../../../i18n";

export class WinnersMeeting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      winners: this.props.winners,
      save_data: [],
    };
  }

  componentDidMount() {}

  render() {
    let { winners, lang } = this.props;
    return (
      <React.Fragment>
        <table className="table table-responsive">
          <thead>
            <tr>
              <th>{i18n.t("sl_no")}</th>
              <th>{i18n.t("title")}</th>
              <th>{i18n.t("name")}</th>
              <th>{i18n.t("username")}</th>
              <th>{i18n.t("target_amount")}</th>
              <th>{i18n.t("latest_bid_amount")}</th>
            </tr>
          </thead>
          <tbody>
            {winners.length > 0 &&
              winners.map((item, i) => {
                return (
                  <tr>
                    <td className="text-center">{i + 1}</td>
                    <td>
                      {lang === "ar"
                        ? item?.auction_title_ar
                        : item?.auction_title}
                    </td>
                    <td>{item?.name}</td>
                    <td>{item?.username}</td>
                    <td>{item?.target_amount}</td>
                    <td>{item?.bid_amount}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </React.Fragment>
    );
  }
}
